import appCountries from "../../views/appSettings/countries.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "countries";
  const params = ["page", "limit"];

  $stateProvider.state("countries", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCountries,
      },
    },
    reloadOnSearch: false,
    data: { title: "Countries" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/countries/countries.urls.js